import { render } from "./RequestRefundIndex.vue?vue&type=template&id=5b91e3a4&scoped=true"
import script from "./RequestRefundIndex.vue?vue&type=script&lang=js"
export * from "./RequestRefundIndex.vue?vue&type=script&lang=js"

import "./RequestRefundIndex.vue?vue&type=style&index=0&id=5b91e3a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b91e3a4"]])

export default __exports__